



















export default {
	name: 'Welcome',
	data() {
		return {
			// inputField: '',
			loading: false,
			// organizationName: '',
		};
	},
	watch: {
		$route(to, from) {
			// if (!to.paramsId) this.organizationName = '';
		},
	},
	methods: {
		// updateName(value): void {
		// 	this.organizationName = value;
		// },
		// enterpriseLogin(): void {
		// 	if (this.inputField === '') return;
		// 	this.$router.push(`/${this.inputField}/signin/`);
		// 	this.inputField = '';
		// },
		emailLinkHandler() {
			this.$prompt(this.$t('welcome.emailPromptMessage'), this.$t('welcome.emailPromptTitle'), {
				confirmButtonText: this.$t('common.ok'),
				cancelButtonText: this.$t('common.cancel'),
				inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
				inputErrorMessage: this.$t('welcome.invalidEmail'),
			})
				.then(async ({ value }) => {
					try {
						this.loading = true;
						const organization = await this.$store.dispatch('authenticateLink', {
							email: value.toLowerCase(),
							url: window.location.href,
						});

						this.loading = false;
						this.$router.push(`/${organization}/signup`);
					} catch (error) {
						this.loading = false;
						this.$message({
							type: 'error',
							message: this.$translateError(error),
							duration: 10000,
							showClose: true,
						});
						this.$router.push(`/`);
					}
				})
				.catch(() => {
					this.$router.push(`/`);
				});
		},
	},
	async mounted() {
		if (this.$firebase.auth().isSignInWithEmailLink(window.location.href)) return this.emailLinkHandler();
		this.$route.params.id && this.$router.push(`/${this.$route.params.id}/signin`);
	},
};
